import React, { FC } from 'react';
import { ICompany } from 'sections/Company/BlacklistPage/interfaces';

interface IDropdownItem {
  item: ICompany;
  name: string;
  setInputValue: (state: any) => void;
  setFormData: (state: any) => void;
  setFormErrors?: (state: any) => void;
  onDropdownClose?: () => void;
}

const DropdownItem: FC<IDropdownItem> = ({
  item,
  name,
  setInputValue,
  setFormData,
  onDropdownClose,
}: IDropdownItem) => {
  const onCLickHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setInputValue(item.company_name);

    setFormData((state: any) => {
      return {
        ...state,
        [name]: item.company_name,
        website: item.website,
        key_person: item.kyc_person ?? item.profile_person,
        email: item.kyc_email ?? item.profile_email,
        phone: item.kyc_phone ?? item.profile_phone,
      };
    });
    onDropdownClose && onDropdownClose();
  };

  return (
    <li className="company-autocomplete__dropdown-item" onClick={onCLickHandler}>
      <div className={`flag-icon flag-icon-${item.country_code?.toLowerCase()}`} />
      <div className="company-autocomplete__dropdown-item-info">
        <p className="company-autocomplete__dropdown-item-info-line company-name">{item.company_name}</p>
        <p className="company-autocomplete__dropdown-item-info-line">{(item.kyc_email ?? item.profile_email) || '-'}</p>
        <p className="company-autocomplete__dropdown-item-info-line">{(item.kyc_city ?? item.city_name) || '-'}</p>
        <p className="company-autocomplete__dropdown-item-info-line">{(item.kyc_phone ?? item.profile_phone) || '-'}</p>
        <p className="company-autocomplete__dropdown-item-info-line">
          {(item.kyc_person ?? item.profile_person) || '-'}
        </p>
      </div>
    </li>
  );
};

export default DropdownItem;
